import { useEffect, useState } from "react";

import { IService } from "interfaces/Service";

import { useClientRegister } from "contexts/register/ClientContext";

import { AutoComplete } from "../../../Autocomplete";
import Input from "../../../Input";
import { InfoTag } from "../../../InfoTag";

import TextArea from "../../TextArea";
import Select from "../../../Select";

import * as S from "./styles";
import { useDataList } from "hooks/useDataList";

function ProductForm() {
  const {
    product,
    setProduct,
    errors,
    isServiceSelected,
    removeSelectedService,
    selectedServices,
    setSelectedServices,
    removeError,
  } = useClientRegister();

  const { data, isLoading } = useDataList<IService>({
    queryKey: 'listAllServices',
    route: 'services',
    filter: {
      notPage: true,
    }
  });

  const [services, setServices] = useState<IService[]>([]);

  async function retrieveServices() {
    if (!isLoading && data) {
      setServices(data.items);
    }
  }

  useEffect(() => {
    retrieveServices();
  }, [isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <S.Wrapper>
      <S.Form>
        <S.FormColumn>
          <Input
            id="name"
            name="name"
            onChange={(event) =>
              setProduct((value) => {
                value.name = event.target.value;
                return value;
              })
            }
            defaultValue={product?.name}
            label="Nome do produto"
            required={true}
            type="text"
            containerClassName="info-input"
            error={errors.name || errors["product.name"]}
            apiErrorName={"product.name"}
            handleApiErrorRemove={() => removeError("product.name")}
          />

          <Select
            id="type"
            name="type"
            label="Tipo do produto"
            onChange={(event) => {
              const value = event.target.value;
              removeError("product.type");

              if (value === "default") return;

              setProduct((_product) => {
                _product.type = value;
                return _product;
              });
            }}
            defaultValue={product?.type}
            required
            error={errors.type || errors["product.type"]}
          >
            <option value="default">Selecione um tipo do produto</option>

            <option value="PRONTA-RESPOSTA PATRIMONIAL">
              PRONTA-RESPOSTA PATRIMONIAL
            </option>
            <option value="PRONTA-RESPOSTA VEICULAR">
              PRONTA-RESPOSTA VEICULAR
            </option>
          </Select>

          <div>
            <TextArea
              id="details"
              name="details"
              label="Detalhes (opcional)"
              maxLength={250}
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                setProduct((value) => {
                  value.details = event.target.value;
                  return value;
                });
              }}
              required={true}
              defaultValue={product?.details}
              error={errors["product.details"]}
              apiErrorName={"product.details"}
              handleApiErrorRemove={() => removeError("product.details")}
            />
          </div>
        </S.FormColumn>

        <S.FormColumn>
          <S.AutoCompleteContainer>
            {!isLoading && data && (
              <AutoComplete
                id="service"
                label="Selecione ao menos um serviço"
                noOptionsMessage={() => 'Nenhum serviço encontrado'}
                placeholder="Selecione um serviço"
                options={services}
                getOptionLabel={(option) => option.name}
                onChange={(selected) => {
                  if (!isServiceSelected(selected as IService)) {
                    setSelectedServices((list) => [...list, selected as IService]);
                  }
                }}
                isSearchable
                error={
                  (errors.servicesIds && "Nenhum serviço foi selecionado") ||
                  errors["product.servicesIds"]
                }
                apiErrorName="servicesIds"
                handleApiErrorRemove={() => removeError("servicesIds")}
              />
            )}
          </S.AutoCompleteContainer>

          <S.ServicesContainer>
            {selectedServices.length !== 0 && (
              <label>Serviços selecionados</label>
            )}

            <S.ServiceList>
              {selectedServices.map((service) => (
                <InfoTag
                  key={service.id}
                  text={service.name}
                  onClose={() => removeSelectedService(service)}
                />
              ))}
            </S.ServiceList>
          </S.ServicesContainer>
        </S.FormColumn>
      </S.Form>
    </S.Wrapper>
  );
}

export { ProductForm };
